import React from 'react';
import { useTranslation } from 'react-i18next';

export const Compliance: React.FC = () => {
  const { t } = useTranslation();

  return (
    <div className="min-h-screen relative overflow-hidden">
      {/* Animated Background Elements */}
      <div className="fixed inset-0 pointer-events-none">
        <div className="floating-element"></div>
        <div className="floating-element"></div>
        <div className="floating-element"></div>
      </div>

      {/* Hero Section */}
      <section className="relative min-h-[40vh] flex items-center justify-center overflow-hidden">
        <div className="hero-background absolute inset-0">
          <div
            className="absolute inset-0 opacity-30"
            style={{
              backgroundImage: `url("data:image/svg+xml,%3Csvg width='100' height='100' xmlns='http://www.w3.org/2000/svg'%3E%3Cdefs%3E%3Cpattern id='grid' width='100' height='100' patternUnits='userSpaceOnUse'%3E%3Cpath d='M 100 0 L 0 0 0 100' fill='none' stroke='rgba(212, 175, 55, 0.1)' stroke-width='1'/%3E%3C/pattern%3E%3C/defs%3E%3Crect width='100%25' height='100%25' fill='url(%23grid)' /%3E%3C/svg%3E")`,
            }}
          />
        </div>

        <div className="relative z-10 text-center px-4 sm:px-6 lg:px-8 max-w-4xl mx-auto pt-20">
          <div className="hero-badge inline-block px-4 py-2 bg-gold/10 rounded-full mb-6">
            <span className="text-gold font-semibold text-sm uppercase tracking-wider">Legal</span>
          </div>
          <h1 className="text-4xl md:text-5xl font-black text-white mb-6 leading-tight bg-gradient-to-r from-gold to-gold-light bg-clip-text text-transparent">
            {t('compliance.title')}
          </h1>
        </div>
      </section>

      {/* Content Section */}
      <section className="section relative -mt-10">
        <div className="container max-w-4xl mx-auto">
          <div className="bg-surface/80 backdrop-blur-md rounded-2xl border border-gold/20 p-8 md:p-12 shadow-xl shadow-gold/5">
            <p className="text-lg text-gray-300 mb-10 leading-relaxed text-center">
              {t('compliance.description')}
            </p>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
              {/* Company Info */}
              <div className="modern-card">
                <div className="w-12 h-12 bg-gold/10 rounded-xl flex items-center justify-center mb-6">
                  <i className="fas fa-building text-2xl text-gold"></i>
                </div>
                <h3 className="text-xl font-bold text-white mb-4">{t('compliance.companyInfoTitle')}</h3>
                <ul className="space-y-3 text-gray-400">
                  <li className="flex items-start gap-3">
                    <i className="fas fa-check text-gold mt-1"></i>
                    <span>{t('compliance.companyName')}</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <i className="fas fa-check text-gold mt-1"></i>
                    <span>{t('compliance.nib')}</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <i className="fas fa-check text-gold mt-1"></i>
                    <span>{t('compliance.email')}</span>
                  </li>
                </ul>
              </div>

              {/* Registration Info */}
              <div className="modern-card">
                <div className="w-12 h-12 bg-gold/10 rounded-xl flex items-center justify-center mb-6">
                  <i className="fas fa-passport text-2xl text-gold"></i>
                </div>
                <h3 className="text-xl font-bold text-white mb-4">{t('compliance.registrationTitle')}</h3>
                <p className="text-gray-400 mb-4 text-sm leading-relaxed">
                  {t('compliance.registrationDesc')}
                </p>
                <ul className="space-y-3 text-gray-400">
                  <li className="flex items-start gap-3">
                    <i className="fas fa-check text-gold mt-1"></i>
                    <span>{t('compliance.pseNumber')}</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <i className="fas fa-check text-gold mt-1"></i>
                    <span>{t('compliance.pseStatus')}</span>
                  </li>
                </ul>
              </div>
            </div>

            <div className="mt-10 p-6 bg-gold/5 border border-gold/20 rounded-xl text-center">
              <p className="text-gold-light font-medium italic">
                {t('compliance.commitment')}
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};